import DescriptionMobile from './DescriptionMobile';

export default DescriptionMobile;
export { DescriptionMobile };
